import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Select from 'components/Select';
import { thunkFetchEvents } from '@/redux/actions';

const EventPicker = props => {
	const { currentClient, fetchEvents, currentEvent, onPress, handlePickItem } = props;
	const { eventID } = onPress;
	const [eventList, setEventList] = useState([]);

	useEffect(() => {
		loadEvents();
	}, []);

	const loadEvents = async () => {
		const allEvents = await fetchEvents(currentClient.id, 'EventPicker');
		const activeEvents = allEvents.filter(
			event => event.status === 'ACTIVE' && event.id !== Number(currentEvent.id)
		);
		const parsedEventsArr = activeEvents.map(event => {
			return { id: String(event.id), name: `Event #${event.id}: ${event.name}` };
		});
		setEventList(parsedEventsArr);
	};

	const handlePickEvent = eventID => {
		handlePickItem({ eventID });
	};

	return eventList.length ? (
		<div>
			<Select
				data={eventList}
				placeholder="Select an event"
				value={[eventID]}
				onChange={handlePickEvent}
			/>
		</div>
	) : null;
};

const msp = ({ events, clients }) => ({
	events: events.events,
	currentEvent: events.currentEvent,
	currentClient: clients.currentClient,
});
const mdp = dispatch => ({
	fetchEvents: (clientID, from) => dispatch(thunkFetchEvents(clientID, from)),
});

export default connect(msp, mdp)(EventPicker);
